import React from 'react';
import svgPaths from './svgs';

export default function ProprioMark(): React.JSX.Element {
  return (
    <div className="relative size-full" data-name="Proprio Mark">
      <svg className="block size-full" fill="none" preserveAspectRatio="xMaxYMid meet" viewBox="0 0 29 25">
        <g id="ProprioMark">
          <path d={svgPaths.p10ad7200} fill="var(--fill-0, black)" />
          <path d={svgPaths.p842f780} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2e0f5e00} fill="var(--fill-0, black)" />
          <path d={svgPaths.pa28f800} fill="var(--fill-0, black)" />
          <path d={svgPaths.p153c4a80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p3cfdd80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1beed980} fill="var(--fill-0, black)" />
          <path d={svgPaths.p20f8d700} fill="var(--fill-0, black)" />
          <path d={svgPaths.p20f0b700} fill="var(--fill-0, black)" />
          <path d={svgPaths.pc5c7240} fill="var(--fill-0, black)" />
          <path d={svgPaths.p20dd0300} fill="var(--fill-0, black)" />
          <path d={svgPaths.pd5b9df0} fill="var(--fill-0, black)" />
          <path d={svgPaths.p4837680} fill="var(--fill-0, black)" />
          <path d={svgPaths.p195c6000} fill="var(--fill-0, black)" />
          <path d={svgPaths.p3a3b2200} fill="var(--fill-0, black)" />
          <path d={svgPaths.pa9f6b00} fill="var(--fill-0, black)" />
          <path d={svgPaths.p174ce080} fill="var(--fill-0, black)" />
          <path d={svgPaths.p2652a800} fill="var(--fill-0, black)" />
          <path d={svgPaths.p5993e80} fill="var(--fill-0, black)" />
          <path d={svgPaths.p196ae900} fill="var(--fill-0, black)" />
          <path d={svgPaths.p1dea8c70} fill="var(--fill-0, black)" />
        </g>
      </svg>
    </div>
  );
}
